import CameraPictureIcon from "../../../assets/icons/CameraPictureIcon"
import RcmpModalAdd from "../../molecules/ModalAdd"
import styles from "./index.module.scss"
import Webcam from "react-webcam"
import { useCallback, useRef, useState } from "react"
import TrashIcon from "../../../assets/icons/TrashIcon"
import RcmpLoading from "../../atoms/Loading"
import RefreshIcon from "../../../assets/icons/RefreshIcon"

export default function RcmpModalMediaCapture(props) {
  const {
    cTitle,
    bIsOpen,
    buttonCancelText,
    buttonSaveText,
    fnHandleCancel,
    setValue,
    fnSubmitImagaEvidence,
    cFileName,
    fnSwitchCamera,
    cVideoMode,
    bCanSwitchCamera
  } = props

  const camRef = useRef(null)
  const [cImage, fnSetCImage] = useState(undefined)
  const [oImageFile, fnSetOImageFile] = useState(undefined)
  const [bLoadingCam, setFnBLoadingCam] = useState(true)

  async function dataUrlToFile(dataUrl) {
    const res = await fetch(dataUrl)
    const blob = await res.blob()
    return new File([blob], cFileName, { type: "image/png" })
  }

  const capture = useCallback(async () => {
    const response = await dataUrlToFile(camRef.current.getScreenshot())
    fnSetOImageFile(response)
    fnSetCImage(camRef.current.getScreenshot())
  }, [camRef])

  function fnCloseModalMedia() {
    fnSetCImage(undefined)
    fnHandleCancel()
    setFnBLoadingCam(true)
  }

  function fnRemoveImage() {
    fnSetCImage(undefined)
    setFnBLoadingCam(true)
  }

  function fnHandleOnCamLoad() {
    setFnBLoadingCam(false)
  }

  function fnSavePicture() {
    setValue("opae_cvalue", oImageFile)
    fnSubmitImagaEvidence()

    fnSetCImage(undefined)
    fnSetOImageFile(undefined)
  }

  const oVideoConstraints = {
    facingMode: cVideoMode,
    width: 461,
    height: 284
  };

  return (
    <RcmpModalAdd
      isOpen={bIsOpen}
      buttonCancelText={buttonCancelText}
      buttonSaveText={buttonSaveText}
      title={cTitle}
      fnHandleCancel={fnCloseModalMedia}
      fnHandleConfirm={fnSavePicture}
      buttonType={"button"}
      size={"md"}
      disabledSaveButton={cImage ? false : true}
    >
      <div className={styles.contentContainer}>
        {bLoadingCam && (
          <div className={styles.loadingCam}>
            <RcmpLoading bShow={true} />
          </div>
        )}
        {!cImage && (
          <>
            <div className={styles.renderContainer}>
              <Webcam
                ref={camRef}
                height={284}
                width={461}
                screenshotFormat="image/png"
                className={styles.cameraPreview}
                onUserMedia={fnHandleOnCamLoad}
                videoConstraints={oVideoConstraints}
              />
              <div className={styles.optionsButtons}>
                <button onClick={capture}>
                  <CameraPictureIcon fill={"#6CB6E3"} />
                </button>
                {bCanSwitchCamera && (
                  <button onClick={fnSwitchCamera}>
                    <RefreshIcon fill={"#6CB6E3"} />
                  </button>
                )}
              </div>
            </div>
          </>
        )}
        {cImage && (
          <div className={styles.previewContainer}>
            <img src={cImage} />
            <div className={styles.buttonCaptureAgain}>
              <button onClick={fnRemoveImage}>
                <TrashIcon fill={"#6CB6E3"} />
              </button>
            </div>
          </div>
        )}
      </div>
    </RcmpModalAdd>
  )
}
